import React from 'react';

import { Row, TypographyText } from '@components/atoms';

export default function FormValidErrorMessage({ formError }: any) {
  return formError?.id ? (
    <Row>
      <TypographyText type="danger">{formError?.id}</TypographyText>
    </Row>
  ) : null;
}
